import type { OrderStatusKey, UserRole } from '@c214/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';
import { useAuth } from './useAuth';

export interface AdminUserSummary {
  id: number;
  email: string;
  name: string | null;
  phone: string | null;
  role: UserRole;
  createdAt: string;
  ordersCount: number;
}

export interface AdminUsersResult {
  users: AdminUserSummary[];
  total: number;
  page: number;
  pageSize: number;
}

export function useAdminUsers(query: string, statuses: OrderStatusKey[], page: number) {
  const { data: user } = useAuth();
  const statusesParam = statuses.join(',');
  return useQuery({
    queryKey: ['admin', 'users', query, statusesParam, page] as const,
    queryFn: () => {
      const params = new URLSearchParams();
      if (query) params.set('query', query);
      if (statusesParam) params.set('statuses', statusesParam);
      params.set('page', String(page));
      return apiGet<AdminUsersResult>(`/api/admin/users?${params}`);
    },
    enabled: user?.role === 'admin',
  });
}
